"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAYER_EDGE = exports.LAYER_BACK = exports.LAYER_FRONT = exports.EAGLE_SCH_LAYERSET = exports.EAGLE_BRD_LAYERSET = void 0;
exports.isLayerActive = isLayerActive;
exports.isLayerVisible = isLayerVisible;
exports.parsePcbLayer = parsePcbLayer;
exports.defaultEaglePcbLayers = defaultEaglePcbLayers;
exports.getEagleDefaultLayerSets = getEagleDefaultLayerSets;
exports.parseSchLayer = parseSchLayer;
exports.getEagleSchLayerByType = getEagleSchLayerByType;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const common_1 = require("./common");
exports.EAGLE_BRD_LAYERSET = 'eaglebrd';
exports.EAGLE_SCH_LAYERSET = 'eaglesch';
function isLayerActive(layer) {
    return (0, common_1.eagleBoolean)(layer._attributes.active);
}
function isLayerVisible(layer) {
    return (0, common_1.eagleBoolean)(layer._attributes.visible);
}
function parsePcbLayer(id, name) {
    const layerProps = PcbLayerMap.find((l) => id === l.id) || { id, type: sigma_engine_shared_1.PcbLayerType.Other };
    return {
        ...layerProps,
        name,
    };
}
function defaultEaglePcbLayers() {
    return PcbLayerMap.map((l) => ({
        ...l,
        name: l.type.toString(),
    }));
}
function getEagleDefaultLayerSets() {
    return {
        [exports.EAGLE_SCH_LAYERSET]: {
            type: 'layerSet',
            layerSetType: 'schematic',
            id: exports.EAGLE_SCH_LAYERSET,
            layers: SchLayerMap,
        },
        [exports.EAGLE_BRD_LAYERSET]: {
            type: 'layerSet',
            layerSetType: 'pcb',
            id: exports.EAGLE_BRD_LAYERSET,
            layers: defaultEaglePcbLayers(),
        },
    };
}
function parseSchLayer(id, name) {
    const layerProps = SchLayerMap.find((l) => id === l.id) || { id, type: sigma_engine_shared_1.SchLayerType.Other };
    return {
        ...layerProps,
        name,
    };
}
function getEagleSchLayerByType(layer) {
    return SchLayerMap.find((l) => l.type === layer);
}
exports.LAYER_FRONT = 1;
exports.LAYER_BACK = 16;
exports.LAYER_EDGE = 20;
const PcbLayerMap = [
    { id: 1, type: sigma_engine_shared_1.PcbLayerType.F, face: 'F', faceMirrorLayer: 16 },
    { id: 2, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 3, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 4, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 5, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 6, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 7, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 8, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 9, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 10, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 11, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 12, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 13, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 14, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 15, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 16, type: sigma_engine_shared_1.PcbLayerType.B, face: 'B', faceMirrorLayer: 1 },
    { id: 17, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 18, type: sigma_engine_shared_1.PcbLayerType.Inner },
    { id: 19, type: sigma_engine_shared_1.PcbLayerType.Other },
    { id: 20, type: sigma_engine_shared_1.PcbLayerType.Edge },
    { id: 21, type: sigma_engine_shared_1.PcbLayerType.SilkS, face: 'F', faceMirrorLayer: 22 },
    { id: 22, type: sigma_engine_shared_1.PcbLayerType.SilkS, face: 'B', faceMirrorLayer: 21 },
    { id: 23, type: sigma_engine_shared_1.PcbLayerType.Other, face: 'F', faceMirrorLayer: 24 },
    { id: 24, type: sigma_engine_shared_1.PcbLayerType.Other, face: 'B', faceMirrorLayer: 23 },
    { id: 25, type: sigma_engine_shared_1.PcbLayerType.SilkS, face: 'F', faceMirrorLayer: 26 },
    { id: 26, type: sigma_engine_shared_1.PcbLayerType.SilkS, face: 'B', faceMirrorLayer: 25 },
    { id: 27, type: sigma_engine_shared_1.PcbLayerType.SilkS, face: 'F', faceMirrorLayer: 28 },
    { id: 28, type: sigma_engine_shared_1.PcbLayerType.SilkS, face: 'B', faceMirrorLayer: 27 },
    { id: 29, type: sigma_engine_shared_1.PcbLayerType.Mask, face: 'F', faceMirrorLayer: 30 },
    { id: 30, type: sigma_engine_shared_1.PcbLayerType.Mask, face: 'B', faceMirrorLayer: 29 },
    { id: 31, type: sigma_engine_shared_1.PcbLayerType.Paste, face: 'F', faceMirrorLayer: 32 },
    { id: 32, type: sigma_engine_shared_1.PcbLayerType.Paste, face: 'B', faceMirrorLayer: 31 },
    { id: 51, type: sigma_engine_shared_1.PcbLayerType.SilkS, face: 'F', faceMirrorLayer: 52 },
    { id: 52, type: sigma_engine_shared_1.PcbLayerType.SilkS, face: 'B', faceMirrorLayer: 51 },
];
const SchLayerMap = [
    { id: 91, name: sigma_engine_shared_1.SchLayerType.Wire.toString(), type: sigma_engine_shared_1.SchLayerType.Wire },
    { id: 92, name: sigma_engine_shared_1.SchLayerType.Bus.toString(), type: sigma_engine_shared_1.SchLayerType.Bus },
    { id: 93, name: sigma_engine_shared_1.SchLayerType.Pin.toString(), type: sigma_engine_shared_1.SchLayerType.Pin, defaultVisible: true },
    { id: 94, name: sigma_engine_shared_1.SchLayerType.Symbol.toString(), type: sigma_engine_shared_1.SchLayerType.Symbol },
    { id: 95, name: sigma_engine_shared_1.SchLayerType.NameLabel.toString(), type: sigma_engine_shared_1.SchLayerType.NameLabel },
    { id: 96, name: sigma_engine_shared_1.SchLayerType.ValueLabel.toString(), type: sigma_engine_shared_1.SchLayerType.ValueLabel },
    { id: 97, name: sigma_engine_shared_1.SchLayerType.Label.toString(), type: sigma_engine_shared_1.SchLayerType.Label },
    { id: 98, name: sigma_engine_shared_1.SchLayerType.Label.toString(), type: sigma_engine_shared_1.SchLayerType.Label },
    { id: 104, name: sigma_engine_shared_1.SchLayerType.NameLabel.toString(), type: sigma_engine_shared_1.SchLayerType.NameLabel },
    { id: 104, name: sigma_engine_shared_1.SchLayerType.NameLabel.toString(), type: sigma_engine_shared_1.SchLayerType.PinName },
    { id: 104, name: sigma_engine_shared_1.SchLayerType.NameLabel.toString(), type: sigma_engine_shared_1.SchLayerType.PinNumber },
    { id: 150, name: sigma_engine_shared_1.SchLayerType.Label.toString(), type: sigma_engine_shared_1.SchLayerType.Label },
    { id: 256, name: sigma_engine_shared_1.SchLayerType.Junction.toString(), type: sigma_engine_shared_1.SchLayerType.Junction },
];
//# sourceMappingURL=layers.js.map